export default{
    //  localStorage.setItem("nawigacja_dropdowns", JSON.stringify(nawigacja_dropdowns))
    //  JSON.parse(localStorage.getItem("nawigacja_dropdowns"))

    /*global*/
    get(name){
        return localStorage.getItem(name)
    },

    getObj(name){
        return JSON.parse(localStorage.getItem(name))
    },

    set(name,val){
        localStorage.setItem(name, val)
    },

    setObj(name,obj){
        localStorage.setItem(name, JSON.stringify(obj))
    },

    del(name){
        localStorage.removeItem(name)
    },

    exist(name){
        return Boolean(JSON.parse(localStorage.getItem(name)))
    },


    /*poszczególne*/

    // gdy chcemy dodać bilet miesieczny a nie ma takiego klienta -> przekierowanie z dodawania biletu do widoku dodawania klienta

    przeslijInformacjeODodaniuKlientaPrzezDodawanieBiletowJed(){
        this.set("EBUS_dodajKlienta_widokDodajBilet","jed")
    },
    przeslijInformacjeODodaniuKlientaPrzezDodawanieBiletowMsc(){
        this.set("EBUS_dodajKlienta_widokDodajBilet","msc")
    },
    pobierzInformacjeODodaniuKlientaPrzezDodawanieBiletow(){
        return this.get("EBUS_dodajKlienta_widokDodajBilet")
    },
    usunInformacjeODodaniuKlientaPrzezDodawanieBiletow(){
        this.del("EBUS_dodajKlienta_widokDodajBilet")
    },


    // gdy utworzymy klienta i mamy wrócić do formatki

    przeslijInformacjeONowoUtworzonymKliencie(obj){
        this.setObj("EBUS_nowyKlient_object", obj)
    },

   pobierzInformacjeONowoUtworzonymKliencie(){
        return this.getObj("EBUS_nowyKlient_object")
    },

    usunNowoUtworzonegoKlienta(){
        this.del('EBUS_nowyKlient_object')
    },

    // gdy klikamy na typ id w tabeli dostęp i jest to KLIENT - id do filtrowania tabeli

    ustawIdKlientaDoFiltrowania(id){
        this.set('EBUS_KlientIdFilter',id)
    },

    pobierzIdKlientaDoFiltrowania(){
        return this.get('EBUS_KlientIdFilter')
    },

    usunIdKlientaDoFiltrowania(){
        this.del('EBUS_KlientIdFilter')
    },


    // gdy klikamy na typ id w tabeli dostęp i jest to KIEROWCA - id do filtrowania tabeli

    ustawIdKierowcyDoFiltrowania(id){
        this.set('EBUS_KierowcaIdFilter',id)
    },

    pobierzIdKierowcyDoFiltrowania(){
        return this.get('EBUS_KierowcaIdFilter')
    },

    usunIdKierowcyDoFiltrowania(){
        this.del('EBUS_KierowcaIdFilter')
    },

    // gdy klikamy na typ id w tabeli dostęp i jest to PRACOWNIK - id do filtrowania tabeli

    ustawIdPracownikaDoFiltrowania(id){
        this.set('EBUS_PracownikIdFilter',id)
    },

    pobierzIdPracownikaDoFiltrowania(){
        return this.get('EBUS_PracownikIdFilter')
    },

    usunIdPracownikaDoFiltrowania(){
        this.del('EBUS_PracownikIdFilter')
    },


    // przekierowanie i wyszukanie e-przystanku wzgledem id danej trasy

    ustawIdTrasyDoEprzystankow(id){
        this.set('EBUS_TrasaIdDlaEprzystankow',id)
    },

    pobierzIdTrasyDoEprzystankow(){
        return this.get('EBUS_TrasaIdDlaEprzystankow')
    },

    usunIdTrasyDoEprzystankow(){
      this.del('EBUS_TrasaIdDlaEprzystankow')
    },


    // przekeirowanie z obsady na bilety, aby wyszukać pozycje na dany kurs

    ustawWyszukiwanieBiletowZObsad(obj){
        this.setObj('EBUS_WyszukajBiletyZObsad',obj)
    },

    pobierzWyszukiwanieBiletowZObsad(){
        return this.getObj('EBUS_WyszukajBiletyZObsad')
    },
    usunWyszukiwanieBiletowZObsad(){
        this.del('EBUS_WyszukajBiletyZObsad')
    },



    // przekeirowanie z rozliczenia kierowcow na bilety, aby wyszukać pozycje na dany kurs

    ustawWyszukiwanieBiletowZRozliczeniaKierowcow(obj){
        this.setObj('EBUS_WyszukajBiletyZRozliczeniaKierowcow',obj)
    },

    pobierzWyszukiwanieBiletowZRozliczeniaKierowcow(){
        return this.getObj('EBUS_WyszukajBiletyZRozliczeniaKierowcow')
    },
    usunWyszukiwanieBiletowZORozliczeniaKierowcow(){
        this.del('EBUS_WyszukajBiletyZRozliczeniaKierowcow')
    },

    // przekkierowanie do edycji karty ze strony klienta

    ustawKarteDoEdycji(obj){
        this.setObj('EBUS_KartaDoEdycji',obj)
    },

    pobierzKarteDoEdycji(){
        return this.getObj('EBUS_KartaDoEdycji')
    },

    usunKarteDoEdycji(){
        this.del('EBUS_KartaDoEdycji')
    },
    

    // przekkierowanie do dodania biletu na karte ze strony klienta

    ustawDaneKartyDoDodaniaMies(obj){
        this.setObj('EBUS_DaneKartyDoDodaniaMies',obj)
    },

    pobierzDaneKartyDoDodaniaMies(){
        return this.getObj('EBUS_DaneKartyDoDodaniaMies')
    },

    usunDaneKartyDoDodaniaMies(){
        this.del('EBUS_DaneKartyDoDodaniaMies')
    },

    // przekkierowanie do dodania biletu jednorazowego ze strony klienta

    ustawDaneKlientaDoDodaniaJedn(obj){
        this.setObj('EBUS_DaneKlientaDoDodaniaJedn',obj)
    },

    pobierzDaneKlientaDoDodaniaJedn(){
        return this.getObj('EBUS_DaneKlientaDoDodaniaJedn')
    },

    usunDaneKlientaDoDodaniaJedn(){
        this.del('EBUS_DaneKlientaDoDodaniaJedn')
    },

    // przekkierowanie do dodania karty ze strony klienta

    ustawDaneKlientaDoDodaniaKarty(obj){
        this.setObj('EBUS_DaneKlientaDoDodaniaKarty',obj)
    },

    pobierzDaneKlientaDoDodaniaKarty(){
        return this.getObj('EBUS_DaneKlientaDoDodaniaKarty')
    },

    usunDaneKlientaDoDodaniaKarty(){
        this.del('EBUS_DaneKlientaDoDodaniaKarty')
    },



    // zapamietanie ktore kolumny pokazac a ktore ukryc w biletach miesiecznych

    ustawZestawKolumnWBiletachMiesiecznych(arr){
        this.set('EBUS_ZestawKolumnBiletyMiesieczne',arr)
    },

    pobierzZestawKolumnWBiletachMiesiecznych(){
      return this.get('EBUS_ZestawKolumnBiletyMiesieczne')
    },

    usunZestawKolumnWBiletachMiesiecznych(){
      this.del('EBUS_ZestawKolumnBiletyMiesieczne')
    },



    // zapamietanie id kursu do wyszukania lokalizacji busu

    ustawIdKursuDoWyszukaniaLokalizacji(idKursu){
        this.set('EBUS_IdKursuDoWyszukaniaLokalizacji',idKursu)
    },

    pobierzIdKursuDoWyszukaniaLokalizacji(){
      return this.get('EBUS_IdKursuDoWyszukaniaLokalizacji')
    },

    usunIdKursuDoWyszukaniaLokalizacji(){
      this.del('EBUS_IdKursuDoWyszukaniaLokalizacji')
    },

    // zapamietanie obiektu do znalezienia

    ustawObiektDoWyszukaniaCennika(obj){
      this.setObj('EBUS_ObiektDoWyszukaniaCennika',obj)
    },

    pobierzObiektDoWyszukaniaCennika(){
        return this.getObj('EBUS_ObiektDoWyszukaniaCennika')
    },

    usunObiektDoWyszukaniaCennika(){
        this.del('EBUS_ObiektDoWyszukaniaCennika')
    },
    

    // zapamietanie wybranych tras do szukania obsad

    ustawTablicaTrasyObsada(arr){
        this.setObj('EBUS_TablicaTrasyObsada',arr)
    },

    pobierzTablicaTrasyObsada(){
        return this.getObj('EBUS_TablicaTrasyObsada')
    },

    usunTablicaTrasyObsada(){
        this.del('EBUS_TablicaTrasyObsada')
    },

}


// WEBPACK FOOTER //
// ./src/utilities/localStorageService/LSService.js